import React from 'react';
import { IconProps } from '../../types/icon';

const PdfIcon: React.FC<IconProps> = ({ className, size = 16 }) => {
  return (
    <img
      src="/gitex-illustrations/PdfIcon.png"
      alt="PDF"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default PdfIcon;